/**
 * API がレスポンス本文で返した理由（`{ error: '...' }`）を取り出す。
 * 診療科未設定で公開しようとした場合など、利用者に見せるべき理由が入っているときに使う。
 * axios 以外の例外や本文の無い失敗では undefined を返し、呼び出し側の既定文言に任せる。
 */
export const getServerErrorMessage = (error: unknown): string | undefined => {
  if (typeof error !== 'object' || error === null) return undefined;
  const data = (error as { response?: { data?: { error?: unknown } } }).response?.data;
  const message = data?.error;
  return typeof message === 'string' && message.trim() !== '' ? message : undefined;
};
